import { Business } from './business.entity';
import { SiteUtils } from '../site/site.utils';

export class BusinessUtils {

	public static isBusinessFreeTrialActive(business: Business, dateToCheck?: Date){
		const freeTrialEnabled = SiteUtils.isFreeTrialForBusinessEnabled(business);
		return this.isFreeTrialActive(freeTrialEnabled, business?.freeTrialExpires, dateToCheck);
	}

	public static isFreeTrialActive(freeTrialEnabled: boolean, freeTrialExpiresDateString: string, dateToCheck?: Date){
		if(!freeTrialEnabled || !freeTrialExpiresDateString) {
			return false;
		}
		if(!dateToCheck) {
			dateToCheck = new Date();
		}
		const freeTrialExpiresDate = new Date(freeTrialExpiresDateString);

		if (isNaN(freeTrialExpiresDate.getTime())) {
			return false;
		}

		return freeTrialExpiresDate.getTime() > dateToCheck.getTime();
	}
}
